import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

export interface IOption {
  key: number | string;
  value: number | string;
  text: number | string;
}
interface DropdownInputProps extends SelectProps {
  options: IOption[];
  label: string;
  variant?: "standard" | "outlined" | "filled";
  helperText?: any;
  error?: any;
}
export const DropdownInput: React.FunctionComponent<DropdownInputProps> = (
  props
) => {
  return (
    <>
      <FormControl
        variant={props.variant ?? "filled"}
        fullWidth={true}
        size={props.size ?? "medium"}
        error={props.error}
      >
        {/* sx={{ m: 1, minWidth: 120 }} */}
        <InputLabel>{props.label}</InputLabel>
        <Select {...props} fullWidth={true}>
          {props.options?.map((item) => {
            return (
              <MenuItem key={item.key} value={item.value}>
                {item.text}
              </MenuItem>
            );
          })}
        </Select>
        <FormHelperText>{props.helperText}</FormHelperText>
      </FormControl>
    </>
  );
};
